import React from 'react';
import { Modal } from 'antd';
import { useLocation } from 'umi';
import classnames from 'classnames';
import { onHistoryPush } from '@/utils/utils';
import styles from './index.less';

const ModalLayer = ({ children }) => {
  const location = useLocation();
  const { pathname } = location;
  const open = pathname.startsWith('/pointshop/pointsH5/modal');
  const isPointExchange = pathname.includes('PointExchange');

  const goHome = () => onHistoryPush('/pointshop/pointsH5');

  let title = '';
  if (pathname.includes('history')) {
    title = 'Point History';
  } else if (pathname.includes('order')) {
    title = 'Redemption Order';
  } else if (pathname.includes('details')) {
    title = 'Product Details';
  } else if (pathname.includes('orderConfirmation')) {
    title = 'Order Confirmation';
  }

  return (
    <Modal
      open={open}
      width={isPointExchange ? 480 : 632}
      title={title}
      centered
      destroyOnHidden
      maskClosable={false}
      onCancel={goHome}
      footer={null}
      wrapClassName={classnames(styles.modalWrap, isPointExchange && styles.pointExchangeModal)}
    >
      {children}
    </Modal>
  );
};

export default ModalLayer;
